import { SequenceUploadReference } from '../models/sequence-upload-reference';

// The sync-center is a generic UI: it identifies an item by one opaque string and never has to know
// a client code exists. This is the only place that composes it — `parseSequenceParentKey` reads it back.
export const toSequenceParentKey = ({ clientCode, sequenceId }: SequenceUploadReference): string =>
  `${clientCode}:${sequenceId}`;
